import apiData from 'lib/stores/apiData';

const regionISOFromName = (name) => {
  const identifier = apiData.regions.find((region) => {
    return region.name === name;
  }).id;
  return identifier;
};

export default regionISOFromName;
